export default __webpack_public_path__ + "static/media/meet8seat.bc1821d6.svg";